export default {
  methods: {
    filterRows(row, filters) {
      return Object
        .keys(row)
        .every(key =>
          !filters[key] ||
          (row[key] &&
            row[key].toLowerCase().includes(filters[key].toLowerCase())));
    }
  }
};